import { render } from "./Complaint_Recipient.vue?vue&type=template&id=50ca6282"
import script from "./Complaint_Recipient.vue?vue&type=script&lang=js"
export * from "./Complaint_Recipient.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__